export default {
  methods: {
    noDataTemplate(loading, noDataString = 'Ei tuloksia.') {
      return (loading) ? '' : noDataString;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/mixins/no-data-template.js